import { render, staticRenderFns } from "./TagListItems.vue?vue&type=template&id=20319b00&scoped=true&lang=html&"
import script from "./TagListItems.vue?vue&type=script&lang=js&"
export * from "./TagListItems.vue?vue&type=script&lang=js&"
import style0 from "./TagListItems.vue?vue&type=style&index=0&id=20319b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20319b00",
  null
  
)

export default component.exports